// extracted by mini-css-extract-plugin
export default {"dropdownList":"jvK76dc14JPdLajwBqMF","palmBackdrop":"wPmg1lIQwV7fzbNqkYjs"};